export const showedAttendeeColumnList = 'AttendeeListView';

const showColumn = (id: string) => {
    const list = localStorage.getItem(showedAttendeeColumnList) ?? '';
    return list.split(',').includes(id);
};

export { showColumn };